import React from 'react'

import { Tabs } from '@mui/material'
import { PollOutlined } from '@mui/icons-material'
import { styled } from '@mui/material/styles'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { LinkTab, ActiveLabel, activeSvgStyle } from '../AppNav'
import { ReactComponent as TableResults } from '@mike/mike-shared-frontend/media/icons/TableResults'

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid' + theme.palette.grey[300],
  paddingLeft: '30px',
  marginBottom: '10px',
  '& .MuiTabs-indicator': {
    height: 3
  }
}))

const SiteInfoNav = () => {
  const intl = useIntl()

  function usePath() {
    return useLocation().pathname
  }

  const currentPath = usePath()

  let activeTab

  switch (currentPath) {
    case '/site-info/details':
      activeTab = 0
      break
    case '/site-info/cpu':
      activeTab = 1
      break
    case '/site-info/storage':
      activeTab = 2
      break
    default:
      activeTab = 0
  }
  return (
    <StyledTabs
      value={activeTab}
      indicatorColor="secondary"
      textColor="primary"
    >
      <LinkTab
        to={'/site-info/details'}
        label={
          activeTab === 0 ? (
            <ActiveLabel>
              {intl.formatMessage({ id: 'screens.siteInfo.tab.info' })}
            </ActiveLabel>
          ) : (
            <span>
              {intl.formatMessage({ id: 'screens.siteInfo.tab.info' })}
            </span>
          )
        }
        icon={
          <PollOutlined
            style={{
              marginRight: 8,
              ...(activeTab === 0 ? activeSvgStyle : {})
            }}
          />
        }
      />
      <LinkTab
        to={'/site-info/cpu'}
        label={
          activeTab === 1 ? (
            <ActiveLabel>
              {intl.formatMessage({ id: 'screens.siteInfo.tab.cpu' })}
            </ActiveLabel>
          ) : (
            <span>
              {intl.formatMessage({ id: 'screens.siteInfo.tab.cpu' })}
            </span>
          )
        }
        icon={
          <TableResults style={activeTab === 1 ? activeSvgStyle : undefined} />
        }
      />
      <LinkTab
        to={'/site-info/storage'}
        label={
          activeTab === 2 ? (
            <ActiveLabel>
              {intl.formatMessage({ id: 'screens.siteInfo.tab.storage' })}
            </ActiveLabel>
          ) : (
            <span>
              {intl.formatMessage({ id: 'screens.siteInfo.tab.storage' })}
            </span>
          )
        }
        icon={
          <TableResults style={activeTab === 2 ? activeSvgStyle : undefined} />
        }
      />
    </StyledTabs>
  )
}

export default SiteInfoNav
